import { useContext } from 'react'

import { SettingsContext, SettingsCtx } from 'src/components/data/providers/SettingsProvider'

const useSettings = (): SettingsCtx => useContext(SettingsContext)

export default useSettings
